import PendoModal from '../../modal/pendo-modal.vue.js';
import PendoColumnReorder from '../column-reorder/pendo-column-reorder.vue.js';

var script = {
  name: 'PendoColumnChooser',
  components: {
    PendoModal,
    PendoColumnReorder
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    availableColumns: {
      type: Array,
      default: () => []
    },
    disableFirst: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'prop'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    placeholder: {
      type: String
    },
    title: {
      type: String,
      default: 'Manage Columns'
    },
    description: {
      type: String,
      default: 'Add, reorder or remove columns to customize your table.'
    },
    addButtonLabel: {
      type: String
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    confirmButtonConfig: {
      type: Object,
      default: () => ({
        label: 'Save'
      })
    },
    cancelButtonConfig: {
      type: Object,
      default: () => ({
        label: 'Cancel'
      })
    },
    allSelectedText: {
      type: String
    }
  },
  data() {
    return {
      model: [],
      renderColumnReorder: false
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
        if (val) {
          this.$emit('open');
        } else {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    onModalClosed() {
      this.renderColumnReorder = false;
    },
    initialize() {
      this.model = [...new Set([...this.columns])];
      setTimeout(() => {
        this.renderColumnReorder = true;
        this.updateScroll();
      }, 0);
    },
    handleConfirm() {
      this.$emit('confirm', this.model.filter(column => Object.keys(column).length));
      this.isVisible = false;
    },
    handleCancel() {
      this.$emit('cancel');
      this.isVisible = false;
    },
    updateScroll() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.pendo-modal__body');
        if (modalBody) {
          modalBody.scrollTop = modalBody.scrollHeight - modalBody.clientHeight;
        }
      });
    },
    updateColumns(value) {
      this.model = value;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-column-chooser.vue2.js.map
